// Module
var code = "<div ng-include role=\"img\" aria-label=\"{{$ctrl.iconName}}\" ng-style=\"$ctrl.styles\" ng-class=\"$ctrl.iconClasses\" src=\"$ctrl.icon\" aria-hidden=\"true\" name=\"{{$ctrl.iconName}}\"></div> ";
// Exports
export default code;